interface ISingleOption {
  optionKey: string;
  optionValue: string;
}
interface IMultipleOption {
  key: string;
  value: string;
}
interface IData {
  count: number;
  _id?: {
    [key: string]: string | ISingleOption | (ISingleOption | IMultipleOption)[];
  };
}
interface IChartData {
  [key: string]: number;
}

type IGraphChartType = "GRAPH" | "TABLE" | "";

export const getChartType = (data: IData[]): IGraphChartType => {
  if (data.length) {
    const keys = Object.keys(data[0]);
    if (keys.includes("_id")) return "GRAPH";
    else if (keys.includes("formData")) return "TABLE";
  }
  return "";
};

export const handleGraphData = (data: IData[]) => {
  const chartData: IChartData = {};
  for (const graphData of data) {
    const keys = Object.keys(graphData._id);
    const count = graphData.count;
    for (const key of keys) {
      const label = graphData._id[key];
      if (
        label != null &&
        label &&
        (typeof label === "string" || typeof label === "number")
      ) {
        chartData[`${label}`] = (chartData[`${label}`] ?? 0) + count;
      } else if (typeof label === "object" && Array.isArray(label)) {
        for (const labelData of label) {
          if (label != null && Object.keys(label)?.length > 0) {
            const labelDataKey = labelData["value"] ?? labelData["optionValue"];
            chartData[labelDataKey] = (chartData[labelDataKey] ?? 0) + count;
          }
        }
      } else if (typeof label === "object") {
        if (label != null && Object.keys(label).length > 0 && label != null) {
          const labelKey = label["value"] ?? label["optionValue"];
          chartData[labelKey] = (chartData[labelKey] ?? 0) + count;
        }
      }
    }
  }
  return chartData;
};

export const getTrasformedChartData = (getWidgetData) => {
  let chartData = {};

  if (getWidgetData) {
    const chartType = getChartType(getWidgetData);
    if (chartType === "GRAPH") {
      chartData = handleGraphData(getWidgetData);
      return chartData;
    }
  }
  return chartData;
};
